import React from 'react'
import { withIntl, Link } from '../i18n'
import { graphql, withPrefix} from 'gatsby'
import Footer from '../components/Footer'
import WithBlur from '../components/withBlur'

import styles from '../styles/servizi.module.scss'
import Layout from '../components/layout'
import IndustrieSearch from '../components/IndustrieSearch';


class SecondPage extends React.Component {
  render() {
    const industrie = this.props.data.allCockpitIndustrie.edges
    const servizi = this.props.data.allCockpitServizi.edges
    return(
      <Layout
        pageTitle="Industrie"
        pageDescription="Sistemi digitali per ogni tipo di esigenza: dalla progettazione e realizzazione di prodotti IoT a infrastrutture per data management, industria manifatturiera, industria robotica, logistica"
        ogtags={[
          {
            name: 'title',
            content: 'GBR System™ - Industrie servite',
          },
          {
            name: 'description',
            content: 'Sistemi digitali per ogni tipo di esigenza: dalla progettazione e realizzazione di prodotti IoT a infrastrutture per data management, industria manifatturiera, industria robotica, logistica',
          },
          {
            name: 'image',
            content: withPrefix('/seo/gbr-systems-industries.jpg')
          }
        ]}
      >
        <div className={styles.topbar}>
          <WithBlur>
            <Link to={'/soluzioni'}>
              <span className={styles.active}>Soluzioni</span>
            </Link>
            
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span className={styles.inactive}>Industrie</span>
          </WithBlur>
        </div>
        <div className={styles.spacer} />
        <IndustrieSearch
          data={industrie}
          tags={servizi}
        />
        <div className={styles.hideOnMobile}>
          <Footer infos={this.props.data.allCockpitPages.edges} variant={'fixed'} />
        </div>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    allCockpitIndustrie {
      edges {
        node {
          entry {
            Name
            Description
            Tags {
              _id
              link
              display
            }
          }
          properties {
            Name_it
            Name_en
            Description_it
            Description_en
          }
        }
      }
    }
    
    allCockpitServizi {
      edges {
        node {
          id
          entry {
            Name
            Slug
          }
        }
      }
    }
    allCockpitPages {
      edges {
        node {
          id
          entry {
            Slug
            Title
          }
        }
      }
    }
  }
`
export default withIntl(SecondPage)
